import { useMemo } from 'react';
import { useContext } from './context';

export function useActiveTab() {
  const { tab } = useContext();
  const layer = useMemo(() => {
    if (/uncertified/i.test(tab)) return 'boundary-uncertified';
    if (/irrigation/i.test(tab)) return 'irrigation-boundary';
    return 'boundary';
  }, [tab]);

  return { tab, layer, isIrrigation: /irrigation/i.test(tab) };
}
